import React from 'react'
import PropTypes from 'prop-types'
import "./Checkbox.scss"
import HrbTranslate from '../../language/HrbTranslate';

const Checkbox = props => {
    const { params, elementId } = props;

    const handleChecked = () => {
        if (props.onChecked) {
            props.onChecked(elementId, !props.checked);
        }
    }

    return (
        <label className='spark-cb'>
            <input type='checkbox' id={elementId} checked={Boolean(props.checked)}
                disabled={props.disabled} onChange={handleChecked} />
            <label htmlFor={elementId} className='cb-label p2'>
                {props.textKey &&
                    <HrbTranslate text={props.textKey} params={params} />
                }
                {props.text &&
                    <span className='is-unselectable truncate-text'>{props.text}</span>
                }
            </label>
        </label>
    )
}

Checkbox.propTypes = {
    textKey: PropTypes.string,
    text: PropTypes.string,
    params: PropTypes.object,
    checked: PropTypes.bool,
    onChecked: PropTypes.func,
    elementId: PropTypes.string.isRequired,
    disabled: PropTypes.bool
}

export default Checkbox